import React, { useEffect, useState } from 'react';
import SendMessage from './modal/send_message-test.modal';
import Icon from '../forms/icon.component';
import { useLocation } from 'react-router-dom';
import { useDarkMode } from '../../hooks/use-dark-mode.hook';

interface Props {
  message: string;
  variables?: any;
  shortURL?: boolean;
  onCharacterCountChange?: (count: number) => void;
}

const MockupIphoneSMS = React.forwardRef<HTMLDivElement, Props>(
  ({ message, variables, shortURL, onCharacterCountChange }, ref) => {
    const isDarkTheme = useDarkMode();
    const url = ' cl2.mx/8rxylmbaf6';
    const validPaths = [
      '/sendCampaigns/flows-campaigns',
      '/sendCampaigns/fallback-campaigns',
      '/sendCampaigns/standard-campaigns'
    ];
    const location = useLocation();
    const isValidRoute = validPaths.includes(location.pathname);
    const routeFallback = location.pathname === '/sendCampaigns/fallback-campaigns';

    const [showModal, setShowModal] = useState({
      show: false,
      data: { typeModal: 'sms' }
    });
    const handleShowModal = async () => {
      setShowModal({ show: false, data: { typeModal: 'sms' } });
    };

    const replaceVariables = (text: string): string => {
      return text.replace(/{{([^{}]+)}}/g, (_, key) => {
        const variable = Array.isArray(variables)
          ? variables.find((v: any) => v?.header === key)
          : null;
        if (variable) {
          return replaceVariables(variable.value);
        }
        return `{{${key}}}`;
      });
    };
    const getReplacedMessage = () => {
      return replaceVariables(message);
    };

    useEffect(() => {
      const replacedMessage = replaceVariables(message);
      let total = replacedMessage.length;
      if (shortURL) {
        total += url.length;
      }
      if (onCharacterCountChange) {
        onCharacterCountChange(total);
      }
    }, [message, variables, shortURL]);

    return (
      <>
        <div ref={ref} className={isDarkTheme ? 'wrap-iphone-sms-dark' : 'wrap-iphone-sms'}>
          {(message || shortURL) && (
            <div className="preview-container-SMS">
              <div className={isDarkTheme ? 'preview-sms-dark' : 'preview-sms'}>
                {getReplacedMessage()}
                {shortURL && (
                  <span className="fw-bolder text-decoration-underline td-wa-c">{url}</span>
                )}
              </div>
            </div>
          )}
        </div>
        {/* {isValidRoute && (
          <div className={`d-flex justify-content-center mt-5 ${routeFallback ? 'ms-15' : 'me-3'}`}>
            <button
              className="btn btn-info fw-bolder"
              type="button"
              onClick={() => setShowModal({ show: true, data: { typeModal: 'sms' } })}
            >
              <Icon icon="ki-send" size="fs-1" />
              <span className="ms-2"> Enviar Mensaje de prueba</span>
            </button>
            <SendMessage
              show={showModal.show}
              onRequestClose={handleShowModal}
              typeMockup={'sms'}
            />
          </div>
        )} */}
      </>
    );
  }
);

export default MockupIphoneSMS;
